import { sportsApiClient } from '@desktop/globalState/sportsApiClient'
import { clearEventData } from '@desktop/utils/database/utils'

import { useEvent } from './useEvent'

type UseEventState = {
  resetEvent(): Promise<void>
}

export function useEventState(): UseEventState {
  const { event } = useEvent()

  async function resetEvent(): Promise<void> {
    const eventId = event.value.id

    await sportsApiClient.Events.reset(eventId)
    await clearEventData(eventId)
  }

  return {
    resetEvent,
  }
}
